import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 10rem;

  &:not(:first-child) {
    margin-top: 2rem;
  }

  ${({ theme }) => `
    ${theme.breakpoints.up('md')} {
      min-height: 6rem;
    }
  `}
`;

export const Status = styled(Typography)`
  display: flex;
  height: fit-content;
  align-items: center;
  justify-content: space-between;
  padding: 0.8rem 2rem;
  width: 90%;
  color: ${({ theme }) => theme.palette.neutral.var70};
  background-color: ${({ theme }) => theme.palette.success.light};
  border-radius: 1.6rem;
  text-align: center;
  gap: 1rem;
`;
